import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import type { ResourceProps } from 'react-admin';

import PricingRulesList from './PricingRulesList';
import PricingRulesCreate from './PricingRulesCreate';
import PricingRulesEdit from './PricingRulesEdit';

const pricingRulesResource: Omit<ResourceProps, 'children'> = {
  name: 'pricingRules',
  list: PricingRulesList,
  create: PricingRulesCreate,
  edit: PricingRulesEdit,
  icon: AttachMoneyIcon,
  options: { label: 'Pricing Rules' },
};

export default pricingRulesResource;

export { pricingRulesDataProvider } from './dataProvider';
export type { PricingRule, PricingRuleInput, PricingFilters, PageInfo } from './types';
